export const notificationPreferenceAction = {
  showPreferenceList: (state, action) => {
    const { showList, accounts, selectedAccount } = action.payload;

    state.showList = showList;
    state.selectedAccount = selectedAccount || "";

    if (accounts?.length > 0) {
      const filteredAccount = accounts.filter(
        (account) => account?.name === selectedAccount
      );

      state.account = filteredAccount?.[0];
    }
  },
  toggleEditPreference: (state, action) => {
    state.editPreference = action.payload;
  },

  toggleAccountFilter: (state, action) => {
    state.toggleAccount = action.payload;
    state.showList = true;
  },
};
